import messages from './memberMessagingCompose.json' with { type: 'json' };

export const memberMessagingComposeEn: Readonly<typeof messages> = messages;
